import React from "react";
import { Input } from "@fluentui/react-components";
import { Control, Controller } from "react-hook-form";
// import "./resetInput.css";
import { Field } from "./Field";
import { t } from "../../i18n/i18n";

type ControlledZipInputProps = {
  name: any;
  control: Control<any>;
  label: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
};
export const ControlledZipInput = ({
  name,
  control,
  label,
  disabled,
  required,
  placeholder,
}: ControlledZipInputProps) => {
  const formatZipCode = (value: string) => {
    if (value.length <= 3) {
      return value;
    }
    return `${value.slice(0, 3)} ${value.slice(3, 5)}`;
  };

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: required ? t("RequiredField") : false,
        pattern: /^[0-9]+$/,
        minLength: { value: 5, message: t("ZipNumberMustBe5Digits") },
        maxLength: { value: 5, message: t("ZipNumberMustBe5Digits") },
      }}
      render={({
        field: { value, onChange },
        fieldState: { error, invalid },
        formState: { disabled: formDisabled },
      }) => {
        return (
          <Field
            label={label}
            required={required ?? false}
            validationMessage={error ? error.message : undefined}
            validationState={error ? "error" : undefined}
          >
            <Input
              type="text"
              value={value ? formatZipCode(value.toString()) : ""}
              onChange={(e, data) => {
                const rawValue = data.value.replace(/\D/g, "")?.slice(0, 5);
                onChange(rawValue);
              }}
              disabled={(disabled || formDisabled) ?? false}
              placeholder={placeholder}
            />
          </Field>
        );
      }}
    />
  );
};
